export const craftyDataExampleData1 = {
  members: { 'test@test.com': true, 'test2@test2.com': true },
  _: true
}